@use "~theme/typographyV2" as typography;
@use "~components/TextInput/tokensV2" as TextInput;
@use "react-select-overridesV2" as ReactSelectOverrides;

.errorMessage {
  @include TextInput.error-message;
}

.container {
  margin: 4px 0 8px;
  margin-top: 15px;
}

.label {
  @include typography.field-label;
  font-size: 12px;
}

.dropdownIndicator {
  display: block;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 18px solid #40668C;
  transition: all 0.3s ease;
}

.dropdownIndicatorOpen {
  transform: rotate(-180deg);
}

.clearIndicator {
  margin-right: 5px;
}

.reactSelect {
  @include ReactSelectOverrides.overrides;
  font-family: typography.$font-mont;
}

.invalid {
  @include ReactSelectOverrides.error-overrides;
}
